import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=cde8209c&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cde8209c')) {
      api.createRecord('cde8209c', component.options)
    } else {
      api.reload('cde8209c', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=cde8209c&", function () {
      api.rerender('cde8209c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N2sebWrya0Xw/JS/videoIframe.vue"
export default component.exports